import { gql } from '../../../../__generated__';

export const UPDATE_NOTICE_ORDER_STATUS_BULK = gql(`
 mutation UpdateNoticeAndOrderStatus($where: NoticeAndOrderUniqueIdsInput!, $data: UpdateNoticeAndOrderStatusData!) {
  updateNoticeAndOrderStatus(where: $where, data: $data) {
    message
  }
}`);
